"use client";

import { FormEvent, useState } from "react";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { useIntl } from "react-intl";
import { personalizedDemoDestination } from "../personalizedDemoNavigation";
import { normalizeWebsiteUrlInput } from "../websiteUrlInput";

/** Owns the single website-intent submission flow shared by acquisition CTAs. */
export const usePersonalizedDemoIntentForm = () => {
  const intl = useIntl();
  const router = useRouter();
  const { status } = useSession();
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const normalizeWebsiteUrl = () => {
    setWebsiteUrl(normalizeWebsiteUrlInput(websiteUrl));
  };

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const normalizedWebsiteUrl = normalizeWebsiteUrlInput(websiteUrl);
    if (!normalizedWebsiteUrl || isSubmitting) return;

    setWebsiteUrl(normalizedWebsiteUrl);
    setIsSubmitting(true);
    setError(null);
    try {
      const response = await fetch("/api/onboarding-intents", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ websiteUrl: normalizedWebsiteUrl }),
      });
      if (!response.ok) throw new Error("ONBOARDING_INTENT_FAILED");
      router.push(personalizedDemoDestination(status === "authenticated"));
    } catch {
      setError(
        intl.formatMessage({
          id: "home.personalizedDemo.error",
          defaultMessage:
            "We couldn't prepare this website. Check the address and try again.",
        }),
      );
      setIsSubmitting(false);
    }
  };

  return {
    websiteUrl,
    setWebsiteUrl,
    normalizeWebsiteUrl,
    isSubmitting,
    error,
    submit,
  };
};

